export default "__VITE_PUBLIC_ASSET__4733c1c8__"